
// ------------------------------------------------------------------------------------------------

// source: https://github.com/uuidjs/uuid

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).slice(1));
}

const GUID_REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

function validate(uuid) {

    return typeof uuid === 'string' && GUID_REGEX.test(uuid);

};

function stringify(arr, offset = 0) {

    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351

    return (
        byteToHex[arr[offset + 0]] +
        byteToHex[arr[offset + 1]] +
        byteToHex[arr[offset + 2]] +
        byteToHex[arr[offset + 3]] +
        '-' +
        byteToHex[arr[offset + 4]] +
        byteToHex[arr[offset + 5]] +
        '-' +
        byteToHex[arr[offset + 6]] +
        byteToHex[arr[offset + 7]] +
        '-' +
        byteToHex[arr[offset + 8]] +
        byteToHex[arr[offset + 9]] +
        '-' +
        byteToHex[arr[offset + 10]] +
        byteToHex[arr[offset + 11]] +
        byteToHex[arr[offset + 12]] +
        byteToHex[arr[offset + 13]] +
        byteToHex[arr[offset + 14]] +
        byteToHex[arr[offset + 15]]
    ).toLowerCase();

};

function parse(uuid) {

    if (!validate(uuid)) {
        throw TypeError('Invalid UUID');
    }

    let v;
    return Uint8Array.of(
        (v = parseInt(uuid.slice(0, 8), 16)) >>> 24,
        (v >>> 16) & 0xff,
        (v >>> 8) & 0xff,
        v & 0xff,

        // Parse ........-####-....-....-............
        (v = parseInt(uuid.slice(9, 13), 16)) >>> 8,
        v & 0xff,

        // Parse ........-....-####-....-............
        (v = parseInt(uuid.slice(14, 18), 16)) >>> 8,
        v & 0xff,

        // Parse ........-....-....-####-............
        (v = parseInt(uuid.slice(19, 23), 16)) >>> 8,
        v & 0xff,

        // Parse ........-....-....-....-############
        // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
        ((v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000) & 0xff,
        (v / 0x100000000) & 0xff,
        (v >>> 24) & 0xff,
        (v >>> 16) & 0xff,
        (v >>> 8) & 0xff,
        v & 0xff
    );

}

// ------------------------------------------------------------------------------------------------

// source: https://developer.mozilla.org/en-US/docs/Web/API/Window/btoa

function base64ToBytes(base64) {
    const binString = atob(base64);
    return Uint8Array.from(binString, (m) => m.codePointAt(0));
}

function bytesToBase64(bytes) {
    const binString = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join("");
    return btoa(binString);
}

// ------------------------------------------------------------------------------------------------

// source: https://github.com/git-ced/uuid-base64-ts

function decodeBase64(base64) {

    //return new Uint8Array(Buffer.from(base64, 'base64url'));
    return Uint8Array.fromBase64(base64, { alphabet: 'base64url' });

};

function encodeUint8Array(uint8Array) {

    //return Buffer.from(uint8Array).toString('base64url');
    return uint8Array.toBase64({ alphabet: 'base64url' });

};

// ------------------------------------------------------------------------------------------------

// source: https://github.com/WebReflection/uint8-to-base64/blob/master/index.js    

function encode(uint8array) {

    const fromCharCode = String.fromCharCode;

    let output = [];

    for (var i = 0, length = uint8array.length; i < length; i++) {
        output.push(fromCharCode(uint8array[i]));
    }

    return btoa(output.join(''));

};

function decode(chars) {

    return Uint8Array.from(atob(chars), (c) => c.charCodeAt(0));

};

// ------------------------------------------------------------------------------------------------

function encodeGuid(uuidv4) {

    const uint8Array = parse(uuidv4);
    // const base64Encoded = encodeUint8Array(uint8Array);
    // return base64Encoded.slice(0, -2);

    //return encodeUint8Array(uint8Array);

    //return base64ToBytes(uint8Array);

    return encode(uint8Array);

};

function decodeGuid(base64Encoded) {

    // const base64 = `${base64Encoded}==`;
    // const uint8Array = decodeBase64(base64);

    //const uint8Array = decodeBase64(base64Encoded);

    //const uint8Array = base64ToBytes(base64Encoded);

    const uint8Array = decode(base64Encoded);

    return stringify(uint8Array);

};

// ------------------------------------------------------------------------------------------------

function generateRandomGuid() {

    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });

    return uuid;

};

function generateGuid() {

    if (crypto && crypto.randomUUID && typeof crypto.randomUUID == 'function')
        return crypto.randomUUID();

    return generateRandomGuid();

};

function generateUid() {

    //return encodeGuid(generateGuid());
    let guid = generateGuid();
    guid.replace(/\-/, '');
    return guid;

};

// ------------------------------------------------------------------------------------------------

export {

    generateGuid,
    generateUid,

    encodeGuid,
    decodeGuid,

}